export default function Hero() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[680px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-primary-50/40"></div>
      <div className="absolute top-0 right-0 w-full md:w-2/3 h-full opacity-10 md:opacity-15">
        <div className="absolute top-10 right-10 w-64 h-64 rounded-full bg-primary-400/30 blur-3xl"></div>
        <div className="absolute bottom-20 right-40 w-80 h-80 rounded-full bg-accent-400/20 blur-3xl"></div>
        <div className="absolute top-1/2 right-20 w-48 h-48 rounded-full bg-primary-300/25 blur-3xl"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-sm font-medium mb-6">
              <i className="ri-fire-fill text-base"></i>
              每日更新 · 全网追踪
            </span>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 leading-tight mb-4 font-heading">
              五一黑料网
              <span className="block text-primary-600 text-2xl md:text-3xl lg:text-4xl mt-2">
                最新黑料吃瓜 · 实时爆料聚合平台
              </span>
            </h1>

            <p className="text-lg md:text-xl text-foreground-600 font-light italic mb-4">
              不放过每一个瓜，不错过每一条料
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0 mb-8">
              五一黑料网汇聚全网最新黑料吃瓜、今日黑料与瓜田爆料内幕，覆盖娱乐圈、网红圈、社会热点等多领域黑料资讯。热点瓜视频实时更新，确保您随时随地掌握第一手爆料内容。无论是最新黑料入口还是网站官网地址，我们为您提供稳定畅通的访问体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                <span>每日更新 <strong className="text-foreground-900">200+</strong> 条爆料</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                <span>覆盖全网 <strong className="text-foreground-900">热搜话题</strong></span>
              </div>
              <div className="flex items-center gap-2 text-sm text-foreground-600">
                <div className="w-2 h-2 rounded-full bg-accent-500"></div>
                <span>7×24小时 <strong className="text-foreground-900">实时速递</strong></span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button
                onClick={() => handleScroll('#cards')}
                className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-flashlight-fill mr-2"></i>
                立即吃瓜
              </button>
              <button
                onClick={() => handleScroll('#contact')}
                className="w-full sm:w-auto px-8 py-3.5 border-2 border-primary-300 text-primary-700 font-semibold rounded-lg hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer text-base"
              >
                <i className="ri-mail-send-line mr-2"></i>
                我要爆料
              </button>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-lg">
            <div className="relative">
              <div className="absolute -inset-3 bg-primary-500/10 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20editorial%20digital%20art%20concept%20representing%20breaking%20news%20and%20entertainment%20gossip%20aggregation%2C%20abstract%20composition%20with%20smartphone%20displaying%20news%20headlines%20against%20warm%20gradient%20background%2C%20floating%20text%20elements%20and%20notification%20bubbles%2C%20deep%20red%20and%20amber%20color%20accents%2C%20clean%20minimalist%20aesthetic%20with%20soft%20glow%20effects%2C%20professional%20digital%20media%20design%2C%20high%20detail%20editorial%20photography%20style%2C%20dark%20warm%20background%20with%20vibrant%20red%20highlights&width=800&height=900&seq=hero-main-2026-v1&orientation=portrait"
                alt="五一黑料网 - 最新黑料吃瓜爆料聚合平台主视觉"
                className="relative w-full h-auto rounded-2xl object-cover"
                width="800"
                height="900"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}